<div *ngIf="isPageReady" class="flex flex-col gap-3 p-1">

  <div *ngIf="!rrd" class="text-red-600">RRD #{{ params.rrdId }} not found.</div>

  <div *ngIf="rrd">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3">
      <table class="qb-info-table">
        <tr><td class="label">RRD</td>          <td class="value">#{{ rrd.id }}</td></tr>
        <tr><td class="label">Job Order</td>    <td class="value">{{ rrd.returnRequest?.joHeader?.id }}</td></tr>
        <tr><td class="label">Account</td>      <td class="value">{{ rrd.returnRequest?.joHeader?.account?.accountName }}</td></tr>
        <tr><td class="label">Manufacturer</td> <td class="value">{{ product?.productType?.manufacturer?.name }}</td></tr>
        <tr><td class="label">Style</td>        <td class="value">{{ product?.productType?.style }}</td></tr>
        <tr><td class="label">Features</td>     <td class="value">{{ variantText }}</td></tr>
        <tr><td class="label">Qty</td>          <td class="value">{{ rrd.qty }}</td></tr>
        <tr><td class="label">Decision</td>     <td class="value">{{ rrd.decision }}</td></tr>
      </table>
    </div>

    <div class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">Why this RRD is unreconciled</div>
      <div *ngIf="rrd.reconciliationExplanation" class="text-sm whitespace-pre-line">{{ rrd.reconciliationExplanation }}</div>
      <div *ngIf="!rrd.reconciliationExplanation" class="text-sm text-muted italic">
        No explanation was recorded when this RRD entered UNRECONCILED.
      </div>
    </div>

    <div class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">Resolution</div>
      <div class="text-sm text-muted mb-2">
        Briefly describe how this was handled outside the system. This note is appended to the explanation above
        and emitted as an audit JoNote when you confirm.
      </div>
      <div class="grid grid-cols-12 gap-3 items-start">
        <label class="col-span-3 font-semibold pt-2">Resolution note</label>
        <textarea pTextarea
                  rows="4"
                  class="col-span-9 w-full"
                  title="Resolution note"
                  [(ngModel)]="resolutionNote"
                  [disabled]="submitting"
                  placeholder="e.g. Credit memo issued manually outside the system; restock fee written off per email from CSR."></textarea>
      </div>
    </div>

    <div class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">Outcome</div>
      <div class="text-sm text-muted mb-2">
        Did the supplier accept or reject this return? This drives whether Proximity restores the customer's
        ledgers (allowance / budget / issuance count). Required.
      </div>
      <div class="flex gap-4 pt-1">
        <label class="flex items-center gap-2 cursor-pointer">
          <p-radioButton name="outcome" value="Accept" [(ngModel)]="outcome" [disabled]="submitting"></p-radioButton>
          <span>Accept &mdash; supplier accepted the return; restore ledgers</span>
        </label>
        <label class="flex items-center gap-2 cursor-pointer">
          <p-radioButton name="outcome" value="Reject" [(ngModel)]="outcome" [disabled]="submitting"></p-radioButton>
          <span>Reject &mdash; supplier rejected the return; do not restore</span>
        </label>
      </div>
    </div>

    <div *ngIf="errorMessage" class="text-red-600 mb-2">{{ errorMessage }}</div>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t">
    <button pButton type="button"
            class="p-button-text"
            [disabled]="submitting"
            (click)="cancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button"
            class="p-button-raised"
            icon="pi pi-check"
            [disabled]="!canSubmit"
            (click)="confirm()">
      <span>Mark as Manually Reconciled</span>
    </button>
  </div>
</div>
